/**
 * Internal user ids (GUIDs) are system keys and are never shown to platform users (owner rule 2026-10-28:
 * "that Id should not show for the users of the platform. it's a system id"). A person is shown by name,
 * else staff number, else "Former employee". Numeric record ids are not affected.
 */
const GUID_RE = /\b[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\b/gi;

export function isGuid(value: string | null | undefined): boolean {
  return !!value && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value.trim());
}

/** The value as shown: null when it is a GUID, otherwise unchanged. */
export function withoutGuid(value: string | null | undefined): string | null | undefined {
  return isGuid(value) ? null : value;
}

/** A request path with every GUID segment replaced by `{id}`. */
export function maskGuids(value: string | null | undefined): string | null | undefined {
  return value ? value.replace(GUID_RE, '{id}') : value;
}
